<template lang="pug">
  .div
    .columns
      .column.is-2
        .field
          label.label Fecha
          .control
            flat-pickr(
              v-model='fecha'
              :config="config"
              class="input"
              :disabled="isDisabled"
            )
      .column.is-2
        .field
          label.label Ubicación:
          .control
            .select.is-dark
              select(v-model="ubicacion" :disabled="isDisabled")
                option(v-for="u in ubicaciones" :key="u.id" :value="u.id") {{ u.valor}}
      .column.is-4
        .field
          label.label Área
          input#checkInst.is-checkradio.is-dark(type='radio', value='1' v-model='area' checked='checked' :disabled="isDisabled")
          label.is-size-6(for='checkInst') Inst.
          input#checkSist.is-checkradio.is-dark(type='radio', value='3' v-model='area' :disabled="isDisabled")
          label.is-size-6(for='checkSist') Sist.
          input#checkCons.is-checkradio.is-dark(type='radio', value='9' v-model='area' :disabled="isDisabled")
          label.is-size-6(for='checkCons') Otra
      .column.is-4
        .field
          label.label Tipo
          input#checkServ.is-checkradio.is-dark(type='radio', value='0' v-model='tipo' checked='checked' :disabled="isDisabled")
          label.is-size-6(for='checkServ') Servicio
          input#checkMaterial.is-checkradio.is-dark(type='radio', value='1' v-model='tipo' :disabled="isDisabled")
          label.is-size-6(for='checkMaterial') Material
    .columns
      .column.is-2
        .field
          input#checkPres.is-checkradio.is-dark(type='checkbox' v-model='isPresupuestada' checked='checked' :disabled="isDisabled")
          label.label.is-size-6(for='checkPres') Presupuestada
      .column.is-2(v-show="isPresupuestada")
        .field
          label.label Partida Pres.
            .control
              input.input.is-dark(
                type='text', 
                placeholder='# Partida',
                v-model="partida",
                :disabled="isDisabled"
              )
      .column.is-2(v-show="!isPresupuestada")
        span(v-show="!isPresupuestada") 
          b Partida No Pres.
          br
          span.tag.is-danger
            b {{ this.dataNoPresupuestada.cantidad | currency }}
      .column.is-3
        .field
          label.label Solicita
          TypeaheadProveedor(:options="usuarios" :optionSelect="itemSelUser" v-model="itemSelUser" :isDisabled="isDisabled")
      .column.is-5
        .field
          .control
            label.label Justificación de la Asignación
            textarea.textarea.is-dark(placeholder='Justificación de la Asignación' v-model="justificacion" rows="2" :disabled="isDisabled")
    .columns
      .column.is-3
        .field
          label.label Bien material o servicio requerido
            .control
              input.input.is-dark(
                type='text', 
                placeholder='Nombre del Bien o Servicio',
                v-model="nombreBienServicio",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label Entrega
          .control
            .select.is-dark
              select(v-model="entregaInmediata" :disabled="isDisabled")
                option(v-for="ent in entregas" :value="ent" :key="ent.id")
                  | {{ ent.texto }}
      .column.is-2
        .field
          label.label Condiciones
            .control.has-icons-right
              input.input.is-dark(
                type='number',
                min='0' 
                max='100'
                placeholder='0',
                v-model="condiciones",
                :disabled="isDisabled"
              )
              span.icon.is-medium.is-right
                | %
      .column.is-5
        .field
          .control
            label.label Especificaciones
            textarea.textarea.is-dark(placeholder='Especificaciones...' v-model="especificaciones" rows="2" :disabled="isDisabled")
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Proveedor 1&nbsp
              span.tag(:class="selProveedor1 ? 'is-black': ''" v-show='Object.keys(itemSelProv1).length > 0')
                | {{ itemSelProv1.nombre}} | {{totalP1 | currency}}
            i.material-icons(slot='icon') more_vert
            .high(slot='content')
              .columns
                .column.is-4
                  .field
                    label.label Nombre Proveedor
                    TypeaheadProveedor(:options="proveedores" :optionSelect="itemSelProv1" v-model="itemSelProv1" :isDisabled="isDisabled") 
                .column.is-2
                  .field
                    label.label Total
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='Total',
                          v-model="totalP1",
                          min="0",
                          :disabled="isDisabled"
                        )
                .column.is-2
                  .field
                    label.label IVA
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='0.00',
                          v-model="ivaP1",
                          min="0",
                          :disabled="isDisabled"
                        )
                .column.is-3
                  .field
                    label.label Moneda
                    input#checkM_MN1.is-checkradio.is-dark(type='radio', value='0' v-model='monedaP1' checked='checked' :disabled="isDisabled")
                    label.is-size-6(for='checkM_MN1') MN
                    input#checkM_Ext1.is-checkradio.is-dark(type='radio', value='1' v-model='monedaP1' :disabled="isDisabled")
                    label.is-size-6(for='checkM_Ext1') USD
                .column.is-1
                  .field
                    input#cbP1.is-checkradio.is-danger(type='checkbox' v-model='selProveedor1' :disabled="isDisabled")
                    label.is-size-6(for='cbP1')
              .columns.is-vcentered
                .column.is-6(v-show="!verSpanFile1")
                  .field
                    .file.is-black.has-name
                      label.file-label
                        input.file-input(type='file' ref="inputCotizacion1" @change="previewfileCotizacion($event, 1)" accept="application/pdf" :disabled="isDisabled")
                        span.file-cta
                          span.file-icon
                            i.fas.fa-upload
                          span.file-label
                            | Cotización&mldr;
                        span.file-name
                          | {{ fileCotizacion1.name }}&nbsp
                          button.delete.is-small(@click="deleteFile(1)")
                .column.is-6(v-show="verSpanFile1 && Object.keys(requisicionEdit).length > 0")
                  span.tag.is-black
                    | {{ Object.keys(requisicionEdit).length > 0 ? getFile(requisicionEdit.cotizaciones[0].rutaFileCot) : ''}}
                  a.button.is-danger.is-rounded.is-small(@click="deleteCot(1)")
                    i.fas.fa-times
                .column.is-1
                  .field
                    label.label Usuario
                .column.is-4
                    TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel1" v-model="usuarioSel1" :isDisabled="isDisabled")
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Proveedor 2&nbsp
              span.tag(:class="selProveedor2 ? 'is-black': ''" v-show='Object.keys(itemSelProv2).length > 0')
                | {{ itemSelProv2.nombre}} | {{totalP2 | currency}}
            i.material-icons(slot='icon') more_vert
            .high(slot='content') 
              .columns
                .column.is-4
                  .field
                    label.label Nombre Proveedor
                    TypeaheadProveedor(:options="proveedores" :optionSelect="itemSelProv2" v-model="itemSelProv2" :isDisabled="isDisabled")
                .column.is-2
                  .field
                    label.label Total
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='Total',
                          v-model="totalP2"
                          :disabled="isDisabled"
                        )
                .column.is-2
                  .field
                    label.label IVA
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='0.00',
                          v-model="ivaP2",
                          min="0",
                          :disabled="isDisabled"
                        )
                .column.is-3
                  .field
                    label.label Moneda
                    input#checkM_MN2.is-checkradio.is-dark(type='radio', value='0' v-model='monedaP2' checked='checked' :disabled="isDisabled")
                    label.is-size-6(for='checkM_MN2') MN
                    input#checkM_Ext2.is-checkradio.is-dark(type='radio', value='1' v-model='monedaP2' :disabled="isDisabled")
                    label.is-size-6(for='checkM_Ext2') USD
                
                .column.is-1
                  .field
                    input#cbP2.is-checkradio.is-danger(type='checkbox' v-model='selProveedor2' :disabled="isDisabled")
                    label.is-size-6(for='cbP2')
              .columns.is-vcentered
                .column.is-6(v-show="!verSpanFile2")
                  .field
                    .file.is-black.has-name
                      label.file-label
                        input.file-input(type='file' ref="inputCotizacion2" @change="previewfileCotizacion($event, 2)" accept="application/pdf" :disabled="isDisabled")
                        span.file-cta
                          span.file-icon
                            i.fas.fa-upload
                          span.file-label
                            | Cotización&mldr;
                        span.file-name
                          | {{ fileCotizacion2.name }}&nbsp
                          button.delete.is-small(@click="deleteFile(2)")
                .column.is-6(v-show="verSpanFile2 && Object.keys(requisicionEdit).length > 0")
                  span.tag.is-black
                    | {{ Object.keys(requisicionEdit).length > 0 ? getFile(requisicionEdit.cotizaciones[1].rutaFileCot) : ''}}
                  a.button.is-danger.is-rounded.is-small(@click="deleteCot(2)")
                    i.fas.fa-times
                .column.is-1
                  .field
                    label.label Usuario
                .column.is-4
                  TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel2" v-model="usuarioSel2" :isDisabled="isDisabled")
    .columns
      .column.is-12
        bulma-accordion
          bulma-accordion-item
            p.title.is-4.has-text-weight-normal(slot='title')
              | Proveedor 3&nbsp
              span.tag(:class="selProveedor3 ? 'is-black': ''" v-show='Object.keys(itemSelProv3).length > 0')
                | {{ itemSelProv3.nombre}} | {{totalP3 | currency}}
            i.material-icons(slot='icon') more_vert
            .high(slot='content') 
              .columns
                .column.is-4
                  .field
                    label.label Nombre Proveedor
                    TypeaheadProveedor(:options="proveedores" :optionSelect="itemSelProv3" v-model="itemSelProv3" :isDisabled="isDisabled")
                .column.is-2
                  .field
                    label.label Total
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='Total',
                          v-model="totalP3"
                          :disabled="isDisabled"
                        )
                .column.is-2
                  .field
                    label.label IVA
                      .control.has-icons-left.has-icons-right
                        input.input.is-dark(
                          type='text', 
                          placeholder='0.00',
                          v-model="ivaP3",
                          min="0",
                          :disabled="isDisabled"
                        )
                .column.is-3
                  .field
                    label.label Moneda
                    input#checkM_MN3.is-checkradio.is-dark(type='radio', value='0' v-model='monedaP3' checked='checked' :disabled="isDisabled")
                    label.is-size-6(for='checkM_MN3') MN
                    input#checkM_Ext3.is-checkradio.is-dark(type='radio', value='1' v-model='monedaP3' :disabled="isDisabled")
                    label.is-size-6(for='checkM_Ext3') USD
                
                .column.is-1
                  .field
                    input#cbP3.is-checkradio.is-danger(type='checkbox' v-model='selProveedor3' :disabled="isDisabled")
                    label.is-size-6(for='cbP3')
              .columns.is-vcentered
                .column.is-6(v-show="!verSpanFile3")
                  .field
                    .file.is-black.has-name
                      label.file-label
                        input.file-input(type='file' ref="inputCotizacion3" @change="previewfileCotizacion($event, 3)" accept="application/pdf" :disabled="isDisabled")
                        span.file-cta
                          span.file-icon
                            i.fas.fa-upload
                          span.file-label
                            | Cotización&mldr;
                        span.file-name
                          | {{ fileCotizacion3.name }}&nbsp
                          button.delete.is-small(@click="deleteFile(3)")
                .column.is-6(v-show="verSpanFile3 && Object.keys(requisicionEdit).length > 0")
                  span.tag.is-black
                    | {{ Object.keys(requisicionEdit).length > 0 ? getFile(requisicionEdit.cotizaciones[2].rutaFileCot) : ''}}
                  a.button.is-danger.is-rounded.is-small(@click="deleteCot(3)")
                    i.fas.fa-times
                .column.is-1
                  .field
                    label.label Usuario
                .column.is-4
                  TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel3" v-model="usuarioSel3" :isDisabled="isDisabled")
    .columns
      .column.is-3
        .field
          label.label Cotización
            .control.has-icons-left.has-icons-right
              input.input.is-dark(
                type='text', 
                placeholder='Cotización',
                v-model="cotizacion",
                :disabled="isDisabled"
              )
      .column.is-5
        .field
          .control
            label.label Comentarios | Justificación del Gasto
            textarea.textarea.is-dark(placeholder='Comentarios | Justificación del gasto...' v-model="comentarios" rows="2" :disabled="isDisabled")
      .column.is-4
        .field
          .control
            label.label Incluye
            textarea.textarea.is-dark(placeholder='Incluye ..' v-model="incluye" rows="2" :disabled="isDisabled")
    .columns(v-show="datosFaltantes.length > 0")
      .column.is-12
        .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns
      .column.is-offset-4.is-2
        a.button.is-black.is-rounded(@click="checkForm" v-show="activarGuardar")
          | Guardar Datos de Requisición
        a.button.is-black.is-rounded(@click="actualizarDataForm" v-show="activarUpdating")
          | Actualizar Datos de Requisición
        a.button.is-warning.is-rounded(@click="editarDataForm" v-show="activarEditar")
          | Editar Datos de Requisición
        a.button.is-light.is-rounded(@click="cancelEditarDataForm" v-show="activarUpdating")
          | Cancelar Edición
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import TypeaheadProveedor from './TypeaheadProveedor.vue'
  import TypeaheadUsuario from "../../components/usuarios_Componentes/componentes/TypeaheadUsuario.vue"
  import FormAgregarCotizacion from './FormAgregarCotizacion.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'FormRequisicion',
    components: { flatPickr, TypeaheadProveedor, FormAgregarCotizacion, TypeaheadUsuario, BulmaAccordion, BulmaAccordionItem },
    props: {
      usuarios: {
        type: Array,
        default: []
      },
      getDataForm: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        area: null,
        fecha: '',
        tipo: null,
        partida: null,
        ubicacion: null,
        isPresupuestada: true,
        justificacion: null,
        incluye: null,
        cotizacion: null,
        nombreBienServicio: null,
        especificaciones: null,
        comentarios: null,
        condiciones: null,
        entregas: [
          {id: 1, dias: 0, texto:'Inmediata'},
          {id: 2, dias: 7, texto:'7 días'},
          {id: 3, dias: 15, texto:'15 días'},
          {id: 4, dias: 30, texto:'30 días'},
          {id: 5, dias: 60, texto:'60 días'},
          {id: 6, dias: 90, texto:'90 días'},
          {id: 7, dias: 120, texto:'+120 días'},
        ],
        entregaInmediata: false,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        ubicaciones: [
          { id: 'IRGE', valor: 'IRGE' },
          { id: 'TPA', valor: 'TPA' },
          { id: 'CORP', valor: 'CORPORATIVO' },
          { id: 'LPG_DUCTO', valor: 'DUCTO' },
          { id: 'EB00', valor: 'EB00' },
          { id: 'EB01', valor: 'EB01' },
          { id: 'EB02', valor: 'EB02' },
          { id: 'EB03', valor: 'EB03' },
          { id: 'EB04', valor: 'EB04' },
          { id: 'ERM', valor: 'ERM-TLAUTLA' }
        ],
        dataNoPresupuestada: {},
        proveedores: [],
        itemDataPort1: {},
        itemDataPort2: {},
        itemDataPort3: {},
        itemDataPortA: {},
        itemDataUser: {},
        itemSelProv1: {},
        itemSelProv2: {},
        itemSelProv3: {},
        itemSelProvSelect: {},
        itemSelUser: {},
        activarGuardar: true,
        activarEditar: false,
        activarUpdating: false,
        userPlantel: {},
        userRevisa: {},
        userAutoriza: {},
        userJefeArea: {},
        totalP1: 0,
        monedaP1: null,
        totalP2: 0,
        monedaP2: null,
        totalP3: 0,
        monedaP3: null,
        ivaP1: 0,
        ivaP2: 0,
        ivaP3: 0,
        isDisabled: false,
        dataRequisiones: {},
        datosFaltantes: [],
        fileCotizacion1: '',
        fileCotizacion2: '',
        fileCotizacion3: '',
        usuarioSel1: {},
        usuarioSel2: {},
        usuarioSel3: {},
        selProveedor1: true,
        selProveedor2: false,
        selProveedor3: false,
        selProvedorSelected: 1,
        itemSelProveedor: {},
        verSpanFile1: false,
        verSpanFile2: false,
        verSpanFile3: false
      }
            
    },
    watch: {
      usuarios () {
        this.userAutoriza = this.usuarios.find( user => user.id === '1554871609265')
        this.userRevisa = this.usuarios.find( user => user.id === '1571850179002')
      },
      getDataForm () {
        if (this.getDataForm) {
          this.activarGuardar = true
        } else {
          this.activarGuardar = false
        }
      },
      isPresupuestada() {
        if (!this.isPresupuestada) {
          this.checkNoPresupuestada()
        }
      },
      ubicacion() {
        switch (this.ubicacion) {
          case 'IRGE':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'IRGE' && user.cargo === '001')
            break
          case 'TPA':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'TPA' && user.cargo === '001')
            break
          case 'CORP':
            this.userPlantel = this.usuarios.find( user => user.id === '1554871609265')
            break
          case 'LPG_DUCTO':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'LPG_DUCTO' && user.cargo === '001')
            break
          case 'EB00':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'LPG_DUCTO' && user.cargo === '001')
            break
          case 'EB01':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'LPG_DUCTO' && user.cargo === '001')
            break
          case 'EB02':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'LPG_DUCTO' && user.cargo === '001')
            break
          case 'EB03':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'LPG_DUCTO' && user.cargo === '001')
            break
          case 'EB04':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'LPG_DUCTO' && user.cargo === '001')
            break
          case 'ERM':
            this.userPlantel = this.usuarios.find( user => user.ubicacion === 'LPG_DUCTO' && user.cargo === '001')
            break
        
          default:
            break
        }
      },
      area () {
        switch (this.area) {
          case '1':
            this.userJefeArea = this.usuarios.find( user => user.departamento === 1 && user.jefeArea === 1)
            break
          case '3':
            this.userJefeArea = this.usuarios.find( user => user.departamento === 3 && user.jefeArea === 1)
            break
        
          default:
            this.userJefeArea = this.userAutoriza
            break
        }
      },
      selProveedor1() {
        if (this.selProveedor1) {
          this.changeProveedorSel(1)
        }
      },
      selProveedor2() {
        if (this.selProveedor2) {
          this.changeProveedorSel(2)
        }
      },
      selProveedor3() {
        if (this.selProveedor3) {
          this.changeProveedorSel(3)
        }
      },
      totalP1 () {
        this.ivaP1 = (this.totalP1 * 16) / 100
      },
      totalP2 () {
        this.ivaP2 = (this.totalP2 * 16) / 100
      },
      totalP3 () {
        this.ivaP3 = (this.totalP3 * 16) / 100
      }
    },
    methods: {
      iniciarComponente() {
        this.limpiarForm()
        this.obtenerProveedores()  
      },
      checkNoPresupuestada() {
        let month = moment(this.fecha).format('MM')
        let year = moment(this.fecha).format('YYYY')

        InventarioServices.getDataNoPresupuesta(this.ubicacion, year, month)
          .then( resp => {
            console.log(resp)
            if (resp.length > 0) {
              this.dataNoPresupuestada = resp[0]
            } else {
              console.log('No hubo datos')
            }
          })
          .catch( e => console.log(e))
      },
      obtenerProveedores () {
        InventarioServices.getProveedores()
          .then( resp => {
            this.proveedores = resp
            if (Object.keys(this.requisicionEdit).length > 0) {
              this.rellenarDataForm()
            }
          })
          .catch( e => console.log(e) )
      },
      checkForm () {
        this.datosFaltantes = []
        if (this.area && this.tipo && this.ubicacion && this.cotizacion && this.nombreBienServicio && this.condiciones && this.incluye &&
          this.especificaciones && this.comentarios && Object.keys(this.itemSelUser).length > 0 && this.selProvedorSelected > 0 &&
          Object.keys(this.itemSelProv1).length > 0 && this.monedaP1 && this.totalP1 && 
          Object.keys(this.itemSelProv2).length > 0 && this.monedaP2 && this.totalP2 &&  
          Object.keys(this.itemSelProv3).length > 0 && this.monedaP3 && this.totalP3) {
          console.log('Datos completos')
          this.enviarDataForm()
        } else {
          console.log('Datos Faltantes')

          if (!this.area) {
            this.datosFaltantes.push('El área es requerida.')
          }

          if (!this.condiciones) {
            this.datosFaltantes.push('Las condiciones de compra son requeridas.')
          }

          if (!this.tipo) {
            this.datosFaltantes.push('El tipo es requerido.')
          }

          if (!this.ubicacion) {
            this.datosFaltantes.push('La ubicación es requerida.')
          }

          if (!this.cotizacion) {
            this.datosFaltantes.push('La cotización es requerida.')
          }

          if (!this.nombreBienServicio) {
            this.datosFaltantes.push('El nombre del bien o servicio es requrido.')
          }

          if (!this.especificaciones) {
            this.datosFaltantes.push('Las especificaciones son requeridas.')
          }

          if (!this.comentarios) {
            this.datosFaltantes.push('Los comentarios son requeridos.')
          }

          if (Object.keys(this.itemSelUser).length == 0) {
            this.datosFaltantes.push('El usuario solicitante es requerido.')
          }

          if (this.selProvedorSelected == 0) {
            this.datosFaltantes.push('Es necesario que seleccione un proveedor.')
          }

          if (!this.totalP1 > 0) {
            this.datosFaltantes.push('El total del Proveedor 1 es requerido.')
          }
          if (!this.totalP2 > 0) {
            this.datosFaltantes.push('El total del Proveedor 2 es requerido.')
          }
          if (!this.totalP3 > 0) {
            this.datosFaltantes.push('El total del Proveedor 3 es requerido.')
          }
          
          if (!this.monedaP1) {
            this.datosFaltantes.push('El tipo de moneda del Proveedor 1 es requerido.')
          }
          if (!this.monedaP2) {
            this.datosFaltantes.push('El tipo de moneda del Proveedor 2 es requerido.')
          }
          if (!this.monedaP3) {
            this.datosFaltantes.push('El tipo de moneda del Proveedor 3 es requerido.')
          }
          
          if (Object.keys(this.itemSelProv1).length == 0) {
            this.datosFaltantes.push('El proveedor 1 es requerido')
          }

          if (Object.keys(this.itemSelProv2).length == 0) {
            this.datosFaltantes.push('El proveedor 2 es requerido')
          }

          if (Object.keys(this.itemSelProv3).length == 0) {
            this.datosFaltantes.push('El proveedor 3 es requerido')
          }
          
          if (this.fileCotizacion1 === '') {
            this.datosFaltantes.push('Debe agregar un archivo pdf para la cotización del proveedor 1.')
          }

          if (this.fileCotizacion2 === '') {
            this.datosFaltantes.push('Debe agregar un archivo pdf para la cotización del proveedor 2.')
          }

          if (this.fileCotizacion3 === '') {
            this.datosFaltantes.push('Debe agregar un archivo pdf para la cotización del proveedor 3.')
          }

          if (!this.incluye) {
            this.datosFaltantes.push('Lo que inlcuye el bien o material es requerido.')
          }
          
        }
      },
      enviarDataForm () {
        console.log('enviarDataForm')
        let provedorSel = {}
        let totalSel = 0
        let monedaSel = 0
        let ivaSel = 0
        let subtotalSel = 0

        switch (parseInt(this.selProvedorSelected)) {
          case 1:
            console.log(1)
            provedorSel = this.itemSelProv1
            totalSel = this.totalP1
            monedaSel = this.monedaP1
            ivaSel = this.ivaP1
            subtotalSel = Number(this.totalP1) - Number(this.ivaP1)
            break
          case 2:
            console.log(2)
            provedorSel = this.itemSelProv2
            totalSel = this.totalP2
            monedaSel = this.monedaP2
            ivaSel = this.ivaP2
            subtotalSel = Number(this.totalP2) - Number(this.ivaP2)
            break
          case 3:
            console.log(3)
            provedorSel = this.itemSelProv3
            totalSel = this.totalP3
            monedaSel = this.monedaP3
            ivaSel = this.ivaP3
            subtotalSel = Number(this.totalP3) - Number(this.ivaP3)
            break
          default:
            console.log(0)
            provedorSel = null
            totalSel = null
            monedaSel = null
            ivaSel = null
            subtotalSel = null
            break
        }

        let $is_presupuestada = 0
        if (this.isPresupuestada) {
          $is_presupuestada = 1
        } else {
          $is_presupuestada = 0
        }



        let items = [
          {
            idUsuario: this.usuarioSel1.id,
            usuario: this.usuarioSel1.nombre,
            file: this.fileCotizacion1,
            fileName: this.fileCotizacion1.name,
            idCot: Object.keys(this.requisicionEdit).length > 0 ? this.requisicionEdit.cotizaciones[0].idCotizacion : null,
            status: this.fileCotizacion1 === '' ? false : true
          },
          {
            idUsuario: this.usuarioSel2.id,
            usuario: this.usuarioSel2.nombre,
            file: this.fileCotizacion2,
            fileName: this.fileCotizacion2.name,
            idCot: Object.keys(this.requisicionEdit).length > 0 ? this.requisicionEdit.cotizaciones[1].idCotizacion : null,
            status: this.fileCotizacion2 === '' ? false : true
          },
          {
            idUsuario: this.usuarioSel3.id,
            usuario: this.usuarioSel3.nombre,
            file: this.fileCotizacion3,
            fileName: this.fileCotizacion3.name,
            idCot: Object.keys(this.requisicionEdit).length > 0 ? this.requisicionEdit.cotizaciones[2].idCotizacion : null,
            status: this.fileCotizacion3 === '' ? false : true
          }
        ]

        let myObjForm = {
          fecha: this.fecha,
          ubicacion: this.ubicacion,
          area: parseInt(this.area),
          tipo: parseInt(this.tipo),
          partida: this.isPresupuestada? this.partida : 'No Pres.',
          condiciones: parseInt(this.condiciones),
          entregaI: parseInt(this.entregaInmediata.dias),
          presupuestada: $is_presupuestada,
          userSolicita: this.itemSelUser,
          justificacion: this.justificacion,
          nombreBienServicio: this.nombreBienServicio,
          especificaciones: this.especificaciones,
          incluye: this.incluye,
          cotizacion: this.cotizacion,
          comentarios: this.comentarios,
          proveedor1: this.itemSelProv1,
          proveedor2: this.itemSelProv2,
          proveedor3: this.itemSelProv3,
          proveedorAsignado: this.selProvedorSelected,
          totalP1: Number(this.totalP1),
          totalP2: Number(this.totalP2),
          totalP3: Number(this.totalP3),
          monedaP1: Number(this.monedaP1),
          monedaP2: Number(this.monedaP2),
          monedaP3: Number(this.monedaP3),
          ivaP2: Number(this.ivaP2),
          ivaP1: Number(this.ivaP1),
          ivaP3: Number(this.ivaP3),
          cotizaciones: items,
          userPlantel: this.userPlantel,
          userAutoriza: this.userAutoriza,
          userJefeArea: this.userJefeArea,
          userRevisa: this.userRevisa,
          provedorSel: provedorSel,
          totalSel: Number(totalSel),
          monedaSel: parseInt(monedaSel),
          ivaSel: Number(ivaSel),
          subtotalSel: Number(subtotalSel)
        }
        console.log(myObjForm)
        
        this.dataRequisiones = Object.assign({}, this.dataRequisiones, myObjForm)
        this.isDisabled = true
        this.activarGuardar = false
        this.activarEditar = true
        this.$emit('send-FormReq', this.dataRequisiones)
      },
      editarDataForm () {
        console.log('Editar')
        this.isDisabled = false
        this.activarGuardar = false
        this.activarEditar = false
        this.activarUpdating = true
      },
      cancelEditarDataForm () {
        console.log('Cancel Editar, regresa a Editar true')
        this.isDisabled = true
        this.isDisabled = true
        this.activarGuardar = false
        this.activarEditar = true
        this.activarUpdating = false
      },
      actualizarDataForm () {
        console.log('actualizar, regresa a estado inicial')
        this.activarGuardar = false
        this.activarEditar = true
        this.activarUpdating = false
        this.enviarDataForm()
      },
      previewfileCotizacion(event, cot) {
        console.log(cot)
        console.log(event)
        switch (cot) {
          case 1:
            this.fileCotizacion1 = event.target.files[0]
            break
          case 2:
            this.fileCotizacion2 = event.target.files[0]
            break
          case 3:
            this.fileCotizacion3 = event.target.files[0]
            break
        
          default:
            break
        }
      },
      deleteFile (cot) {
        console.log(cot)
        console.log(this.$refs.inputCotizacion1.files)
        switch (cot) {
          case 1:
            this.fileCotizacion1 = ''
            this.$refs.inputCotizacion1.value = ""
            this.verSpanFile1 = true
            break
          case 2:
            this.fileCotizacion2 = ''
            this.$refs.inputCotizacion2.value = ""
            this.verSpanFile2 = true
            break
          case 3:
            this.fileCotizacion3 = ''
            this.$refs.inputCotizacion3.value = ""
            this.verSpanFile3 = true
            break
        
          default:
            break
        }
      },
      changeProveedorSel (numProv) {
        console.log(numProv)
        switch (numProv) {
          case 1:
            this.selProvedorSelected = 1
            this.selProveedor2 = false
            this.selProveedor3 = false
            break
          case 2:
            this.selProvedorSelected = 2
            this.selProveedor1 = false
            this.selProveedor3 = false
            break
          case 3:
            this.selProvedorSelected = 3
            this.selProveedor1 = false
            this.selProveedor2 = false
            break
          default:
            this.selProvedorSelected = 0
            this.selProveedor1 = false
            this.selProveedor2 = false
            this.selProveedor3 = false
            break
        }
      },
      cancelProveedorSel (numProv) {
        console.log(numProv)
        switch (numProv) {
          case 1:
            this.itemSelProveedor = 0
            break
          case 2:
            this.itemSelProveedor = 0
            break
          case 1:
            this.itemSelProveedor = 0
            break
        
          default:
            break
        }
      },
      rellenarDataForm () {
        console.log('Here 🙋🙋🙋') 
        this.area = this.requisicionEdit.area
        this.fecha = this.requisicionEdit.fechaReg
        this.tipo = this.requisicionEdit.tipo
        this.partida = this.requisicionEdit.partida
        this.ubicacion = this.requisicionEdit.ubicacion
        this.isPresupuestada = this.requisicionEdit.presupuestada
        this.justificacion = this.requisicionEdit.justificacion
        this.incluye = this.requisicionEdit.incluye
        this.cotizacion = this.requisicionEdit.cotizacion
        this.nombreBienServicio = this.requisicionEdit.nombreBienMat
        this.especificaciones = this.requisicionEdit.especificaciones
        this.comentarios = this.requisicionEdit.comentarios
        this.condiciones = this.requisicionEdit.condiciones
        this.entregaInmediata = this.requisicionEdit.entrega
        this.totalP1 = this.requisicionEdit.totalP1
        this.monedaP1 = `${this.requisicionEdit.monedaP1}`
        this.totalP2 = this.requisicionEdit.totalP2
        this.monedaP2 = `${this.requisicionEdit.monedaP2}`
        this.totalP3 = this.requisicionEdit.totalP3
        this.monedaP3 = `${this.requisicionEdit.monedaP3}`

        this.itemSelUser = this.usuarios.find((user) => user.id === this.requisicionEdit.idUser_sol)
        this.entregaInmediata = this.entregas.find((ent) => ent.dias === this.requisicionEdit.entrega)
        this.itemSelProv1 = this.proveedores.find((prov) => prov.id === this.requisicionEdit.id_prov1)
        this.itemSelProv2 = this.proveedores.find((prov) => prov.id === this.requisicionEdit.id_prov2)
        this.itemSelProv3 = this.proveedores.find((prov) => prov.id === this.requisicionEdit.id_prov3)

        this.usuarioSel1 = this.usuarios.find((user) => user.id === this.requisicionEdit.cotizaciones[0].idUsuarioCot)
        this.usuarioSel2 = this.usuarios.find((user) => user.id === this.requisicionEdit.cotizaciones[1].idUsuarioCot)
        this.usuarioSel3 = this.usuarios.find((user) => user.id === this.requisicionEdit.cotizaciones[2].idUsuarioCot)
        this.verSpanFile1 = true
        this.verSpanFile2 = true
        this.verSpanFile3 = true
        switch (this.requisicionEdit.proveedorSel) {
          case 1:
            this.selProveedor1 = true
            break
          case 2:
            this.selProveedor2 = true
            break
          case 3:
            this.selProveedor3 = true
            break
        }

      },
      getFile(file) {
        let filename = ''
        let parts = file.split('/')
        return parts[6]
      },
      deleteCot (nCot) {
        switch (nCot) {
          case 1:
            this.verSpanFile1 = false
            break
          case 2:
            this.verSpanFile2 = false
            break
          case 3:
            this.verSpanFile3 = false
            break
          default:
            break
        }
      }, 
      limpiarForm() {
        this.area = null
        this.fecha = null
        this.tipo = null
        this.partida = null
        this.ubicacion = null
        this.isPresupuestada = true
        this.justificacion = null
        this.incluye = null
        this.cotizacion = null
        this.nombreBienServicio = null
        this.especificaciones = null
        this.comentarios = null
        this.condiciones = null
        this.itemSelProv1 = {}
        this.itemSelProv2 = {}
        this.itemSelProv3 = {}
        this.itemSelProvSelect = {}
        this.itemSelUser = {}
        this.userPlantel = {}
        this.userRevisa = {}
        this.userAutoriza = {}
        this.userJefeArea = {}
        this.totalP1 = 0
        this.monedaP1 = null
        this.totalP2 = 0
        this.monedaP2 = null
        this.totalP3 = 0
        this.monedaP3 = null
        this.ivaP1 = 0
        this.ivaP2 = 0
        this.ivaP3 = 0
        this.fileCotizacion1 = ''
        this.fileCotizacion2 = ''
        this.fileCotizacion3 = ''
        this.usuarioSel1 = {}
        this.usuarioSel2 = {}
        this.usuarioSel3 = {}
      }
    },
    created () {
      this.iniciarComponente()
    },
    
    computed: {
      ...mapState(['userLogin', 'requisicionEdit'])
    }
  }
</script>

<style lang="css" scoped>
  .is-top-bottom {
    margin-top: 32px;
  }
  .field.is-botton-check {
    margin-top: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/FormRequisicion.vue